// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__2CeVX","no_content":"page_no_content__7cPeM"};